import React, { Component } from 'react';

import { connect } from 'react-redux';
import _ from 'lodash';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import chartUtils from '../../../util/chartUtils';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import { getStats } from '../CFDActions';
import CFDChart from './CFDChart';
import FlowStats from './FlowStats';
import ArrivalDepTrendsChart from './ArrivalDepChart';

import './../CFD.scss';

class WallboardCFDChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      avgData: []
    };
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.props.getStats(+this.props.dates.startDate, +this.props.dates.endDate, this.props.data);
    }
  }

  render() {
    // the rates are worked out after the CFD's data arrives, and not at all for a range with no data
    const ratesLoading = this.props.isLoading || (!!this.props.data.length && !Array.isArray(this.props.arrivalDepTrends));
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Cumulative Flow Diagram</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          
          <div className="button_tools">
            <Options
              chart="cfd"
              showAvgChart
              showMetrics
              options={{
                avgChartTooltip: 'Arrival & throughput rates chart'
              }}
            />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          <FlowStats id="stats" data={this.props.stats} />
          {this.props.avgChart && (chartUtils.hasRates(this.props.arrivalDepTrends) ? (
            <ArrivalDepTrendsChart data={this.props.arrivalDepTrends} />
          ) : (
            <CardPlaceholder title="Arrival & throughput rates" shape="table" loading={ratesLoading} />
          ))}
        </div>
        <div className="diagram_details">
          <CFDChart id="CFD" data={this.props.data} stats={this.props.stats} />
          <NoData show={!this.props.data.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getStats: (from, to, data) => dispatch(getStats(from, to, data))
  };
};

const mapStateToProps = state => {
  return {
    dates: state.filters.dates,
    avgChart: state.filters.cfd.avgChart,
    dateFormat: state.filters.dateFormat,
    data: state.cfd.data,
    arrivalDepTrends: state.cfd.arrivalDepTrends,
    stats: state.cfd.stats,
    isLoading: state.cfd.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WallboardCFDChart);
